<template>
  <p class="mb-0 body-2-2 text-14 text-subcolor">
    {{ label }}
    <span class="font-bold text-dark">{{ highlightedAmount }}</span>
    <span class="text-12">· {{ chargeInfo.rateLabel }}</span>
  </p>
</template>

<script>
export default {
  name: 'PaymentChargeInfo',
  props: {
    chargeInfo: {
      type: Object,
      default: () => ({})
    },
    // set when the charge amount is already the main figure, so this line shows the base amount instead
    baseAmountLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    label() {
      return this.baseAmountLabel ? this.$t('hotel.payment-method.equivalent-to') : this.$t('hotel.payment-method.billed-in');
    },
    highlightedAmount() {
      return this.baseAmountLabel || this.chargeInfo.amountLabel;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/v2/payment/PaymentChargeInfo.vue